import catalog from './verseCatalog.json';

export const topicOptions = [
  { id: 'anxious', label: 'Anxiety' }, { id: 'night', label: 'Sleep' },
  { id: 'grief', label: 'Grief' }, { id: 'guidance', label: 'Guidance' },
  { id: 'grateful', label: 'Gratitude' }, { id: 'love', label: 'Relationships' },
  { id: 'hope', label: 'Hope' }, { id: 'strength', label: 'Strength' },
  { id: 'morning', label: 'Starting the day' }
];

const toContentItem = (item, topic, dayIndex) => ({
  id: item.id,
  type: 'verse',
  topicTags: item.topicTags,
  text: item.text,
  reference: item.reference,
  translation: item.translation,
  dayIndex,
  source: 'curated',
  editorialStatus: item.editorialStatus,
  ttsAudioUrl: item.tts.audioUrl,
  videoUrl: null,
  trackTopic: topic
});

export const masterCatalog = catalog.items;

export const tracks = Object.fromEntries(topicOptions.map(({ id: topic }) => {
  const matching = catalog.items.filter((item) => item.topicTags.includes(topic));
  const pool = matching.length ? matching : catalog.items;
  return [topic, Array.from({ length: 365 }, (_, index) => toContentItem(pool[index % pool.length], topic, index + 1))];
}));

export const getContentFor = (topic = 'anxious', index = 0) => tracks[topic]?.[index % 365] || tracks.anxious[0];
